type Round = { isFundraising: boolean; stage: string | null; amount: number | null }

const STAGES: Record<string, string> = { PRE_SEED: 'Pre-seed', SEED: 'Seed' }

function stageLabel(stage: string): string {
  const known = STAGES[stage]
  if (known) return known
  const words = stage.replaceAll('_', ' ').toLowerCase()
  return words.charAt(0).toUpperCase() + words.slice(1)
}

function amountLabel(amount: number): string {
  const trim = (n: number) => String(Math.round(n * 10) / 10)
  if (amount >= 1_000_000) return `$${trim(amount / 1_000_000)}M`
  if (amount >= 1_000) return `$${trim(amount / 1_000)}k`
  return `$${amount}`
}

/** "Seed · $2.5M", "Seed" when no amount is set, "Not raising" when the startup is not. */
export function roundLabel(round: Round): string {
  if (!round.isFundraising) return 'Not raising'
  const parts = [
    round.stage ? stageLabel(round.stage) : null,
    round.amount ? amountLabel(round.amount) : null,
  ]
  return parts.filter(Boolean).join(' · ') || 'Raising'
}
